var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaso4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 95,
    viewBox: "0 0 95 95",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.58,
    d: "M47.4654 72.8837C61.4891 72.8837 72.8575 61.5112 72.8575 47.4825C72.8575 33.4538 61.4891 22.0813 47.4654 22.0813C33.4417 22.0813 22.0733 33.4538 22.0733 47.4825C22.0733 61.5112 33.4417 72.8837 47.4654 72.8837Z",
    fill: "url(#paint0_radial_1569_7307)"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.5222 57.2967C38.3657 50.0297 45.4744 36.4445 50.2136 36.4445C54.4788 36.4445 42.157 56.3489 46.8962 56.3489C50.2136 56.3489 52.5831 46.3967 54.9527 46.3967C57.3223 46.3967 54.0049 54.9271 55.9005 54.9271C58.2701 54.9271 59.6919 51.1358 59.6919 51.1358",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1569_7307",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.0697 51.2476) scale(30.758 29.5382)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#FCFDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F4F6F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#E6EBEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#D3DBE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#B9C6D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#9AACBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#758EA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#4B6B87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#345978"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaso4);
export default __webpack_public_path__ + "static/media/paso_4.b83bb33cfbf99a61976ae78b695dbbb2.svg";
export { ForwardRef as ReactComponent };